<div class="resizer"
     [ngClass]="resizerClass"
     *ngIf="!customHandler">
</div>
<ng-content></ng-content>
